import { ButtonLink } from '@designsforhealth/dfh-react-components'
import { FormGroup } from '@material-ui/core'
import styled, { css, keyframes } from 'styled-components'

// differ text (i.e. `from` vs `0%`) to produce two separate animation names for toggling
const highlightA = keyframes`
  from {
    outline: #de4f56 solid 1px;
  }

  50% {
    outline: #de4f56 solid 1px;
  }

  to {
    outline: transparent solid 1px;
  }
`

const highlightB = keyframes`
  0% {
    outline: #de4f56 solid 1px;
  }

  50% {
    outline: #de4f56 solid 1px;
  }

  100% {
    outline: transparent solid 1px;
  }
`

export const Form = styled(FormGroup)<{ $highlight: 0 | 1 | null }>`
  display: flex;
  flex-direction: row;
  margin: 0 0 20px;
  padding: 5px 0;
  outline-offset: 2px;
  border-radius: 5px;
  ${({ $highlight }) =>
    $highlight === 0
      ? css`
          animation: ${highlightA} forwards 3s;
        `
      : $highlight === 1
        ? css`
            animation: ${highlightB} forwards 3s;
          `
        : ''};

  && .MuiIconButton-root:hover {
    background: transparent !important;
  }
`

export const Text = styled.p`
  font-size: 12px;
  text-align: left;
  margin: 0;
`

export const Button = styled(ButtonLink)`
  color: ${({ theme }) => theme.colors.brand.red};
  font-size: inherit;
  font-weight: bold;

  &:hover {
    text-decoration: underline;
  }
`
